module.exports = __webpack_public_path__ + "static/redsnapper-887a98fed6c5fa7f2059db11bedd303d.png";